
import { mapMutations, mapState } from "vuex";

export default {
    props: ["room"],
    data (){
        return {
            isLoading: false,
            myAnswers: [],
        }
    },
    computed: {
        ...mapState({
            user: state => state.auth.user,
            pollingItem: state => state.live_polling.item,
        }),
    },
    mounted(){
        this.setMyRoom(this.room);

        setTimeout(() => {
            this.$socket.emit("getPollingItem", this.room, (res) => {
                console.log("getPollingItemCallback ->", res);
                if(res.item && res.item.room == this.room){
                    this.setPollingItem(res.item);
                    this.myAnswers = res.my_answers;
                }
            });
        }, 500);
    },
    methods: {
        ...mapMutations({
            setMyRoom: "live_polling/setMyRoom",
            setPollingItem: "live_polling/setItem",
        }),
        getPollingOptionClass(item){
            var isAnswered = _.find(this.myAnswers, { polling: this.pollingItem.id });
            if(isAnswered || this.pollingItem.is_show_result){
                return `btn-${ isAnswered?.answer == item? "" : "outline-" }theme disabled`;
            }

            return "btn-outline-theme";
        },
        onSelectPollingOption(item){
            if(!this.isLoading){
                this.isLoading = true;

                const pollingObj = {
                    room: this.room,
                    polling: this.pollingItem.id, 
                    question: this.pollingItem.question, 
                    answer: item 
                };

                this.$socket.emit("submitPollingAnswer", pollingObj, (res) => {
                    console.log("submitPollingAnswerCallback->", res);
                    if(res.code == 200){
                        this.myAnswers.push({ polling: this.pollingItem.id, answer: item });
                        if(this.room != "test_room"){
                            this.$store.dispatch('auth/onTriggerAnalytics', { action: `send@${ this.room }@polling_answer`, event: "click_event", route: this.$route.path });
                        }
                    }else{
                        this.$swal({
                            title: res.message.title,
                            text: res.message.text,
                            icon: res.message.icon,
                        });
                    }
                    this.isLoading = false;
                })
            }
        }
    },
    watch: {

    }
}
